<template>
  <md-config-provider size="small">
    <router-view />
  </md-config-provider>
</template>

<style lang="less">
* {
  scrollbar-color: rgba(157, 165, 183, 0.7) transparent;
  /* 滑块颜色  滚动条背景颜色 */
  scrollbar-width: thin;
  /* 滚动条宽度有三种：thin、auto、none */
}

#app,
.app {
  height: 100%;
}
</style>
